
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import {
  TooltipProvider,
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";

export function SidebarToggleButton() {
  const { state, toggleSidebar } = useSidebar();
  
  return (
    <div className="mt-2 flex justify-center">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={toggleSidebar}
              className={cn(
                "flex items-center justify-center rounded-full p-1.5",
                "transition-all duration-200 ease-in-out",
                "text-sidebar-foreground/70 hover:text-sidebar-foreground",
                "hover:bg-sidebar-accent/30 focus:outline-none focus:ring-2 focus:ring-sidebar-ring focus:ring-offset-1"
              )}
              aria-label={state === "collapsed" ? "Expand sidebar" : "Collapse sidebar"}
            >
              {state === "collapsed" ? 
                <ChevronRight size={18} /> : 
                <ChevronLeft size={18} />
              }
            </button>
          </TooltipTrigger>
          <TooltipContent side="right" align="center" hidden={state !== "collapsed"}>
            {state === "collapsed" ? "Expand sidebar" : "Collapse sidebar"}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
